/*
 * Copyright (c) 2023-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';

class WebPagePreview extends Component {

    render() {
        let {URL} = this.props
        return (
            <div className={"w-full h-full overflow-hidden pointer-events-none"}>
                <iframe id="inlineFrameExample"
                        title="Inline Frame Example"
                        className={"w-full h-full "}
                        width="1460"
                        height="1080"
                        style={{zoom: 0.5}}
                        src={URL}>
                </iframe>
            </div>
        );
    }
}

WebPagePreview.propTypes = {};

export default WebPagePreview;